import React from 'react';
import { Section } from './ui/Section';
import { X, Check } from 'lucide-react';
export function ProblemSection() {
  return <Section background="navy" className="relative" data-id="element-152">
      <div className="text-center mb-12" data-id="element-153">
        <h2 className="text-3xl md:text-4xl font-serif text-white mb-6" data-id="element-154">
          Esto no es "higiene del sueño".
          <br data-id="element-155" />
          <span className="text-slate-400" data-id="element-156">Y no es "piensa positivo".</span>
        </h2>
        <p className="text-xl text-slate-300 max-w-2xl mx-auto leading-relaxed" data-id="element-157">
          Es un protocolo corto para un problema específico:{' '}
          <span className="text-[#d4a574] font-medium" data-id="element-158">
            mujeres que funcionan todo el día… y se rompen por dentro en la
            noche.
          </span>
        </p>
      </div>

      <div className="bg-[#0f172a]/50 backdrop-blur-sm p-8 md:p-10 rounded-2xl border border-white/5 max-w-3xl mx-auto shadow-xl" data-id="element-159">
        <h3 className="text-lg font-medium text-slate-400 mb-6 uppercase tracking-widest text-center" data-id="element-160">
          Si te suena familiar:
        </h3>

        <ul className="space-y-4" data-id="element-161">
          {['estás agotada pero tu mente sigue en modo trabajo', 'te despiertas y la cabeza arranca con miedo al mañana', 'ya probaste té, melatonina, apps, videos de respiración', 'y aun así vuelves al mismo lugar…'].map((item, index) => <li key={index} className="flex items-start gap-4 text-lg text-slate-200" data-id="element-162">
              <div className="mt-1 min-w-[24px] h-6 rounded-full bg-red-500/10 flex items-center justify-center" data-id="element-163">
                <X size={14} className="text-red-400" data-id="element-164" />
              </div>
              <span data-id="element-165">{item}</span>
            </li>)}
        </ul>
      </div>

      <div className="mt-12 text-center max-w-2xl mx-auto" data-id="element-166">
        <p className="text-xl md:text-2xl font-serif text-white leading-relaxed" data-id="element-167">
          No necesitas más información. Necesitas una{' '}
          <span className="text-[#d4a574] italic" data-id="element-168">secuencia</span> que le diga a
          tu sistema nervioso:
        </p>
        <p className="mt-4 text-2xl md:text-3xl font-serif text-[#d4a574]" data-id="element-169">
          "Ya cerramos. Ya basta. Mañana seguimos."
        </p>
      </div>
    </Section>;
}